module.exports = __webpack_public_path__ + "media/images/icon_check-a920fcb4720ffd5c72631c3136c48712.png";